import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import store from '@/store'
import { GET_ACCESS_MODEL } from '@/store/root/getters'

import Home from '@/components/views/home/Home.vue'
import AddEvent from '@/components/views/add-event/AddEvent.vue'
import AddCall from '@/components/views/add-call/AddCall.vue'
import DayEvents from '@/components/views/day-events/DayEvents.vue'
import ClientEvents from '@/components/views/client-events/ClientEvents.vue'
import Login from '@/components/views/login/Login.vue'
import ShowEvent from '@/components/views/show-event/ShowEvent.vue'
import ShowCall from '@/components/views/show-call/ShowCall.vue'
import Users from '@/components/views/users/Users.vue'
import Clients from '@/components/views/clients/Clients.vue'
import Menu from '@/components/views/menu/Menu.vue'
import ForgetPassword from '@/components/views/forget-password/ForgetPassword.vue'
import SetPassword from '@/components/views/set-password/SetPassword.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/users',
    name: 'users',
    component: Users
  },
  {
    path: '/clients',
    name: 'clients',
    component: Clients
  },
  {
    path: '/menu',
    name: 'menu',
    component: Menu
  },
  {
    path: '/add-event',
    name: 'addEvent',
    component: AddEvent
  },
  {
    path: '/add-call',
    name: 'addCall',
    component: AddCall
  },
  {
    path: '/day-events/:date',
    name: 'dayEvents',
    component: DayEvents
  },
  {
    path: '/client-events/:id',
    name: 'clientEvents',
    component: ClientEvents
  },
  {
    path: '/forget-password',
    name: 'forgetPassword',
    component: ForgetPassword
  },
  {
    path: '/set-password',
    name: 'setPassword',
    component: SetPassword
  },
  {
    path: '/events/:id',
    name: 'showEvent',
    component: ShowEvent
    // component: () => import(/* webpackChunkName: "about" */ '@/components/views/about/About.vue')
  },
  {
    path: '/calls/:id',
    name: 'showCall',
    component: ShowCall
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const skipAuthPages = ['login', 'forgetPassword', 'setPassword']
  if (!skipAuthPages.includes(to.name || 'home') && !store.getters[GET_ACCESS_MODEL]) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
